import React from 'react';

const filterGroups = [];

export default function ShowroomFilters({ activeFilters = [], onToggleFilter }) {
  return (
    <aside className="w-64 flex-shrink-0 bg-white border-r border-gray-200 p-4 h-full overflow-y-auto space-y-5 font-sans">
      <h3 className="text-sm font-bold text-gray-800 tracking-tight">Filters</h3>

      {filterGroups.map((group) => (
        <div key={group.title} className="space-y-2">
          <h4 className="text-[10px] font-bold text-gray-500 tracking-wider uppercase">
            {group.title}
          </h4>
          <div className="flex flex-wrap gap-1.5">
            {group.options.map((option) => {
              const isActive = activeFilters.includes(option);
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => onToggleFilter?.(option)}
                  className={`px-2.5 py-1 text-[11px] rounded-md font-medium transition-all ${
                    isActive
                      ? 'bg-slate-800 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {option}
                </button>
              );
            })}
            {group.moreCount && (
              <button
                type="button"
                className="px-2 py-1 text-[11px] rounded-md font-medium text-gray-500 bg-gray-50 border border-gray-200 hover:bg-gray-100"
              >
                +{group.moreCount} More
              </button>
            )}
          </div>
        </div>
      ))}
    </aside>
  );
}